export default {"src":"/_next/static/media/hotel-icon.d1bbcd73.svg","height":94,"width":143,"blurWidth":0,"blurHeight":0};